import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=21dddbde&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=ts&"
export * from "./Navigation.vue?vue&type=script&lang=ts&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=21dddbde&lang=css&scoped=true&"
import style1 from "./Navigation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dddbde",
  null
  
)

export default component.exports